import { useEffect } from 'react';
import { useSelector, useDispatch } from 'react-redux';
import { Box } from '@mui/material';

import MedicalHistory from './MedicalHistory';
import ReferralHistory from './ReferralHistory';
import { treatmentPlanActions, medicalHistoryActions } from '../../../../store';
import { TreatmentPlanPages } from '../constants/general';

function MedicalAndReferralHistory() {
  const dispatch = useDispatch();
  const { treatmentPlanId: currentTreatmentPlanId, errorState } = useSelector(
    (state: any) => state.medicalHistories,
  );
  const { current: treatmentPlan } = useSelector((state: any) => state.treatmentPlans);
  useEffect(() => {
    if (!currentTreatmentPlanId) return;
    let count = 0;
    for (const key in errorState) {
      count += errorState[key];
    }
    dispatch(
      treatmentPlanActions.updateBadge({
        [TreatmentPlanPages.MedInfo]: count,
      }),
    );
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [errorState]);

  useEffect(() => {
    if (!treatmentPlan?.id) {
      dispatch(medicalHistoryActions.clearState());
      return;
    }
    if (treatmentPlan?.id != currentTreatmentPlanId) {
      dispatch(medicalHistoryActions.clearState());
    }
    dispatch(
      medicalHistoryActions.updateState({ key: 'treatmentPlanId', data: treatmentPlan?.id }),
    );
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [treatmentPlan]);

  return (
    <Box>
      <MedicalHistory />
      <ReferralHistory />
    </Box>
  );
}

export default MedicalAndReferralHistory;
